import { ApplicationStatuses as CommonApplicationStatuses } from '../common/enums/ApplicationStatuses'

export class ApplicationStatuses extends CommonApplicationStatuses {}
